import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rectangle creams/rectangle mango biscuit.png";
import BiscuitImg from "../../../assets/products/rectangle creams/Rectangle-Mango.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 27,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 75,
  },
  {
    grams: 80,
  },
];

export default function MangoRectangleProduct() {
  return (
    <>
      <Helmet>
        <title>
          Rectangle Mango Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Rectangle Mango Cream Biscuits — tropical mango-flavored sandwich biscuits with creamy filling. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Rectangle Mango Cream Biscuit, BearBitz Mango Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/rectangle-cream-biscuit/rectangle-mango"
        />
        <meta
          property="og:title"
          content="Rectangle Mango Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled mango sandwich biscuit in rectangle shape with export-ready packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="MANGO"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF8D00"
        sectionBgColor="#FFEFC2"
        productBgcolor="#FFDE85"
        tableheadBgcolor="#FF8D00"
        tableBgcolor="#FFF9E7"
        footerBgcolor="#FF8D00"
      />
    </>
  );
}
